import { Layers2, CircleHelp, LucideIcon, Settings } from "lucide-react";
import { ProjectPageNav } from "@/store/zustand/layoutStore";
import React from "react";
import ViewsNav, { ViewsNavProps } from "../views/ViewsNav";
import Info from "../LeftNav/Info";
import ProjectConfigNav, {
  ProjectConfigNavProps,
} from "../ProjectConfiguration/ProjectConfigNav";
import { Chat } from "../AI/chat/Chat";
import Icon, { ICONS } from "../Core/Icons";
import { cn } from "@/lib/utils";
import { AI_AGENT } from "@/store/zustand/aiActionStore";

// AI Logo icon matching the editor sidebar style
const AiLogoIcon = ({ className }: { className?: string }) => (
  <Icon
    icon={ICONS.AI_LOGO}
    width={20}
    height={20}
    className={cn(
      "cursor-pointer text-white p-1 w-auto h-6 rounded-sm bg-primary-0 hover:bg-primary-100",
      className,
    )}
  />
);

export interface NavigationItem {
  id: ProjectPageNav;
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  label: string;
  panelComponent?: React.ComponentType<any>;
  panelWidth?: string;
  isCustomIcon?: boolean;
}

export const navigationConfig: NavigationItem[] = [
  {
    id: ProjectPageNav.AIChat,
    icon: AiLogoIcon,
    label: "AI Chat",
    panelComponent: () => {
      return <Chat agent={AI_AGENT.PM_AGENT} />;
    },
    panelWidth: "w-80",
    isCustomIcon: true,
  },
  {
    id: ProjectPageNav.Settings,
    icon: Settings,
    label: "Settings",
    panelComponent: (props: ProjectConfigNavProps) => {
      return <ProjectConfigNav {...props} />;
    },
    panelWidth: "w-64",
  },
  {
    id: ProjectPageNav.Views,
    icon: Layers2,
    label: "Views",
    panelComponent: (props: ViewsNavProps) => {
      return <ViewsNav {...props} />;
    },
    panelWidth: "w-64",
  },
  {
    id: ProjectPageNav.Info,
    icon: CircleHelp,
    label: "Info",
    panelComponent: () => {
      return <Info />;
    },
    panelWidth: "w-64",
  },
];

const navigationMap = new Map<ProjectPageNav, NavigationItem>();
navigationConfig.forEach((item) => {
  navigationMap.set(item.id, item);
});

export const getNavigationItem = (
  id: ProjectPageNav,
): NavigationItem | undefined => {
  return navigationMap.get(id);
};

export const getActiveNavigationItems = (
  activeNav: ProjectPageNav | null,
): NavigationItem[] => {
  if (!activeNav) return [];
  const item = navigationMap.get(activeNav);
  return item ? [item] : [];
};
